const shrineBuffs = {
  shrine_armor: {
    name: 'ShrId6',
    stats: {
      item_armor_percent: 100,
    },
  },
  shrine_combat: {
    name: 'ShrId7',
    stats: {
      shrine_tohit_percent: 200,
      damagepercent: 200,
    },
  },
  shrine_resist_fire: {
    name: 'ShrId8',
    stats: {
      fireresist: 75,
    },
  },
  shrine_resist_cold: {
    name: 'ShrId9',
    stats: {
      coldresist: 75,
    },
  },
  shrine_resist_lightning: {
    name: 'ShrId10',
    stats: {
      lightresist: 75,
    },
  },
  shrine_resist_poison: {
    name: 'ShrId11',
    stats: {
      poisonresist: 75,
      item_poisonlengthresist: 100,
    },
  },
  shrine_skill: {
    name: 'ShrId12',
    stats: {
      item_allskills: 2,
    },
  },
  shrine_mana_regen: {
    name: 'ShrId13',
    stats: {
      manarecoverybonus: 400,
    },
  },
  shrine_stamina: {
    name: 'ShrId14',
  },
  shrine_experience: {
    name: 'ShrId15',
    stats: {
      item_addexperience: 50,
    },
    hidden: true,
  },
};

export default shrineBuffs;
